const API_BASE_URL = process.env.REACT_APP_TRAVEL_API_BASE_URL;

export interface FetchHotelsParams {
  // City code (IATA/City code like 'DEL') from Location API value
  city: string;
  checkIn: string;
  checkOut: string;
  rooms: Array<{
    Adults: number;
    Children: number;
    ChildrenAges: number[] | null;
  }>;
  filters?: {
    StarRating?: number;
    MealType?: string;
    HotelName?: string;
    Amenities?: string[];
    [key: string]: any;
  };
  page?: number;
  limit?: number; // alias: pageSize also accepted by API
}

export interface HotelsPagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface HotelsResponse<T = any> {
  items: T[];
  pagination: HotelsPagination;
}

export const fetchHotels = async (params: FetchHotelsParams): Promise<HotelsResponse> => {
  const res = await fetch(`${API_BASE_URL}/hotels/search`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...params, page: params.page ?? 1 }),
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch hotels (${res.status} ${res.statusText})`);
  }

  return res.json();
};
